/**
 * season_tint.ts — the SEASON / dryness tint (linear RGB; 1,1,1 = each asset's own colour), 2026-09-25
 * visual-realism R9. One uniform shared by every foliage material (lib/instancing.ts `applySeasonTint`) AND the
 * ground's turf layer (lib/wetness.ts), so a season tint moves the meadow and the plants on it together — the
 * grass blades carry the same factor through their layer's own `tint` uniform (`__seasonTint` sets both).
 * Its own module so the ground shader can share it without importing the instancer.
 */
import * as THREE from 'three/webgpu';
import { uniform } from 'three/tsl';

export const seasonTint = new THREE.Vector3(1, 1, 1);
export const seasonTintNode = uniform(seasonTint);
export function setSeasonTint(r: number, g: number, b: number): void { seasonTint.set(r, g, b); }
